var path = '/var/www/mmscny-cms/src/app/common/components/content-sequence/content-sequence.html';
var html = "<div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 content-sequence\"> <div class=seqncList> <h2>Drag & drop the following items to change their sequence</h2> <ol id=slippylist> <li ng-repeat=\"item in list\" class=demo-no-reorder> <div class=seqncContList> <h4> <span class=icon-Move></span> <span class=item-title>{{item.title}}</span> </h4> </div> </li> </ol> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/content-sequence/content-sequence.html
// module id = 715
// module chunks = 0